import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe, formatDate } from "@angular/common";
import { LoaderService } from "../../loader/loader.service";
import moment from 'moment';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ExcelExportComponent } from "@progress/kendo-angular-excel-export";
import { State, process } from '@progress/kendo-data-query';
import { ReportsService } from '../reports.service';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { MatDialog } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { Overlay } from '@angular/cdk/overlay';
import { ToastrService } from 'ngx-toastr';
import { eyeIcon, chevronLeftIcon, downloadIcon } from '@progress/kendo-svg-icons';

@Component({
    selector: 'app-report-view',
    templateUrl: './report-view.component.html',
    styleUrls: ['./report-view.component.css'],
    providers: [DatePipe],
    standalone: false
})
export class ReportViewComponent implements OnInit {
  readonly icons = {
    view: eyeIcon,
    back: chevronLeftIcon,
    download: downloadIcon,
  };

  @ViewChild('excelexport', { static: false }) excelexport: ExcelExportComponent;
  @ViewChild('ReminderMessageStatusReport', { static: false }) ReminderMessageStatusReport: ExcelExportComponent;
  @ViewChild("ReminderMessageStatusDialog") ReminderMessageStatusDialog: TemplateRef<any>;
  @ViewChild("ReminderMessageStatusExport") ReminderMessageStatusExport: TemplateRef<any>;
  @ViewChild('addOnExcelExport', { static: false }) addOnExcelExport: ExcelExportComponent;
  reportName: string = '';
  reportData: any;
  parentId: any;
  reportId: number = 0;
  Date: any;
  month: any;
  firstDay: any;
  lastDay: any;
  todayDate = new Date();
  fromFormatted: string = "";
  toFormatted: string = "";
  endDate: any;
  startDate: any;
  Year: any;
  years: number[] = [];
  selectedYear: number;
  showDate: any;
  paymentreportName: any;
  formGroup: FormGroup;
  searchText: string = '';
  groups: any[] = [];
  months: any[] = [];
  newkendoData: any[] = [];
  flattenedExportData: any[] = [];
  companyName: string = '';
  private scrollPosition = 0;
  public kendoData: GridDataResult = { data: [], total: 0 };
  public originalData: any[] = [];
  public originalChildData: any[] = [];
  public reminderMessageData: GridDataResult = { data: [], total: 0 }
  public gridHeight: number;
  public gridHeight2: number;
  public state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: "and",
      filters: [],
    },
    group: this.groups,
  };
  public childState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: "and",
      filters: [],
    },
    group: this.groups,
  };
  public dropdownValueList: any[] = [
    { text: "Daily", Id: 1 },
    { text: "Weekly", Id: 2 },
    { text: "Monthly", Id: 3 },
    { text: "Annual", Id: 4 },
    { text: "Custom", Id: 5 },
  ];
  public pageableWithAll: any = {
    buttonCount: 5,
    pageSizes: [5, 10, 20, 50, 100, 'All']
  };

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private readonly reportService: ReportsService,
    private readonly overlay: Overlay,
    private readonly toaster: ToastrService
  ) { }

  ngOnInit(): void {
    this.setGridHeight();
    const state = history.state;
    this.reportData = state?.reportData?.queryParams;
    this.reportName = state?.reportData?.queryParams?.Name;
    if (!this.reportData) {
      this.navigateToReports();
    } else {

      this.selectedYear = this.selectedYear || new Date().getFullYear();
      this.formGroup = this.fb.group({
        Report: [null]
      });
      const defaultItem = this.dropdownValueList.find(item => item.text === 'Daily');
      if (defaultItem) {
        this.formGroup.get('Report')?.setValue(defaultItem);
      }
      this.reportName = this.reportData?.Name
      this.reportId = this.reportData?.Id;
      if (this.reportName === 'Storage Report') {
        this.loadStorageReportData();
      } else {

        this.selectedOption(this.reportData);
      }
    }
    this.form = this.fb.group({});
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setGridHeight();
  }

  setGridHeight(): void {
    const headerHeight = 70; // Adjust according to your header and other elements
    const footerHeight = 61;
    const otherElementsHeight = 210;
    const otherElementsHeight2 = 140;
    this.gridHeight = window.innerHeight - headerHeight - footerHeight - otherElementsHeight;
    this.gridHeight2 = window.innerHeight - headerHeight - footerHeight - otherElementsHeight2;
  }
  navigateToReports() {
    this.router.navigate(["reports"]);
  }
  selectedOption(data: any) {
    var IsShow: boolean = true;
    this.selectedYear = new Date().getFullYear();
    this.parentId = data?.value ? data.value.Id : 1;
    this.searchText = "";

    if (this.parentId == 1) {
      this.Date = new Date();
      this.startDate = this.Date;
      this.endDate = this.Date;
    }
    else if (this.parentId == 2) {
      this.firstDay = new Date(this.todayDate.setDate(this.todayDate.getDate() - this.todayDate.getDay()));
      this.fromFormatted = this.firstDay;

      this.lastDay = new Date(
        this.todayDate.setDate(
          this.todayDate.getDate() - this.todayDate.getDay() + 6
        )
      );
      this.toFormatted = this.lastDay;
      this.startDate = this.firstDay;
      this.endDate = this.lastDay;
    }
    else if (this.parentId == 3) {
      const today = new Date();
      this.firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      this.fromFormatted = this.firstDay;
      this.lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.toFormatted = this.lastDay;
      this.startDate = this.firstDay;
      this.endDate = this.lastDay;
    }

    else if (this.parentId == 4) {
      this.startDate = new Date(this.selectedYear, 0, 1);
      this.endDate = new Date(this.selectedYear, 11, 31);
      this.showDate =
        formatDate(this.startDate, 'dd/MM/yyyy', 'en-IN') +
        " to " +
        formatDate(this.endDate, 'dd/MM/yyyy', 'en-IN');
    }
    else if (this.parentId == 5) {
      IsShow = false;
    }

    this.selectedYear = new Date().getFullYear();
    if (IsShow) {
      this.showReports();
    }
  }

  showReports() {
    this.loaderService.show();
    this.selectedYear = this.selectedYear || new Date().getFullYear();
    this.Year = this.selectedYear;
    //load data here via API 
    this.reportService
      .getReport(
        this.reportId.toString(),
        typeof this.startDate === 'string' ? this.startDate : formatDate(this.startDate, 'dd/MM/yyyy', 'en-IN'),
        typeof this.endDate === 'string' ? this.endDate : formatDate(this.endDate, 'dd/MM/yyyy', 'en-IN')
      )
      .subscribe((response: any) => {
        if (response["Success"] === true && response["Data"] != null) {
          this.originalData = response["Data"];
          this.loadGridData();
          this.loaderService.hide();
        } else {
          this.originalData = [];
          this.kendoData.data = [];
          this.loaderService.hide();
        }
      });
  }

  UpdateReportData(value: any) {
    const fromFormatted = moment(value.fromDt).format("YYYY-MM-DD");
    const toFormatted = moment(value.toDt).format("YYYY-MM-DD");
    this.fromFormatted = fromFormatted;
    this.toFormatted = toFormatted;
    this.startDate = fromFormatted;
    this.endDate = toFormatted;
    this.showReports();
  }
  public onExcelExport(): void {
    if (this.reportId == 5) {
      this.selectedCompanyIds = []; // reset
      this.searchControl.setValue('');
      this.dialog.open(this.ReminderMessageStatusExport, {
        width: '40vw',
        autoFocus: false
      })
    }
    else {
      if (this.kendoData.data.length === 0)
        return;

      this.excelexport.save();
    }
  }

  public dataStateChange(state: DataStateChangeEvent, ischild: boolean | null = null): void {
    if (ischild) {
      this.childState = state;
      this.loadchildGridData();
    }
    else {
      this.state = state;
      this.loadGridData();
    }
  }
  loadGridData(): void {
    this.kendoData = process(this.originalData, this.state);
  }

  loadchildGridData(): void {
    this.reminderMessageData = process(this.originalChildData, this.childState);
  }

  filterData(event: string): void {
    this.searchText = event;

    const filtered = this.originalData.filter(item =>
      Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(this.searchText.toLowerCase())
      )
    );

    this.kendoData = process(filtered, this.state);
  }


  clearList(): void {
    this.searchText = '';
    this.kendoData = process(this.originalData, this.state);
  }
  resetChildState(): void {
    this.childState = {
      skip: 0,
      take: 10,
      filter: {
        logic: "and",
        filters: [],
      },
      group: this.groups, // optional: pass [] if you don't want group initially
    };
  }

  onViewClicked(dataItem: any): void {
    if (dataItem?.Id != 0) {
      this.loaderService.show();
      this.companyName = dataItem.Company;
      const gridElement = document.querySelector('.report-grid');
      if (gridElement) {
        this.scrollPosition = gridElement.scrollTop || 0;
      }
      this.resetChildState();
      this.reportService
        .GetReminderMessageStatusReport(
          dataItem.Id,
          typeof this.startDate === 'string' ? this.startDate : formatDate(this.startDate, 'dd/MM/yyyy', 'en-IN'),
          typeof this.endDate === 'string' ? this.endDate : formatDate(this.endDate, 'dd/MM/yyyy', 'en-IN')
        )
        .subscribe((response: any) => {
          if (response["Success"] === true && response["Data"] != null) {
            this.originalChildData = response["Data"] ?? [];
            this.loadchildGridData();
            const dialogRef = this.dialog.open(this.ReminderMessageStatusDialog, {
              width: 'fit-content',
              autoFocus: false,
              restoreFocus: false,
              scrollStrategy: this.overlay.scrollStrategies.block()
            })
            dialogRef.afterOpened().subscribe(() => {
              const html = document.documentElement;
              html.style.overflow = 'hidden';
            });
            this.loaderService.hide();
            dialogRef.afterClosed().subscribe(() => {
              setTimeout(() => {
                if (gridElement) {
                  gridElement.scrollTop = this.scrollPosition;
                  const html = document.documentElement;
                  html.style.overflow = '';
                }
              });
            });
          } else {
            this.originalData = [];
            this.kendoData.data = [];
            this.loaderService.hide();
          }
        });
    }
  }
  loadStorageReportData() {
    this.loaderService.show();
    this.reportService.getStorageReport()
      .pipe(
        finalize(() => this.loaderService.hide())
      )
      .subscribe((response: any) => {
        if (response["Success"] === true && response["Data"] != null) {
          this.originalData = response["Data"];
          this.kendoData = {
            data: this.originalData,
            total: this.originalData.length
          };
          this.loadGridData();
        } else {
          this.kendoData = {
            data: [],
            total: 0
          };
        }
      });
  }

  getStorageColor(percentString: string): string {
    const percent = parseFloat(percentString.replace('%', ''));

    if (percent === 0) return '#808080';
    if (percent <= 50) return '#4CAF50';
    if (percent <= 80) return '#FF9800';
    return '#F44336';
  }

  onRowDoubleClick(event: any): void {
    const cell = (event.target as HTMLElement).closest('kendo-grid-list tr');
    if (!cell) return;

    const index = Array.from(cell.parentElement!.children).indexOf(cell);
    const dataItem = this.kendoData.data[index];

    if (dataItem) {
      this.onViewClicked(dataItem);
    }
  }
  selectedCompanyIds: number[] = [];
  form: FormGroup;
  searchControl = new FormControl('');
  onCheckboxChange(event: any, id: number): void {
    if (event.target.checked) {
      this.selectedCompanyIds.push(id);
    } else {
      const index = this.selectedCompanyIds.indexOf(id);
      if (index !== -1) {
        this.selectedCompanyIds.splice(index, 1);
      }
    }
  }

  exportSelectedCompanies(): void {
    this.dialog.closeAll();
    if (this.selectedCompanyIds.length === 0) {
      alert('Please select at least one company.');
      return;
    }
    this.loaderService.show();
    this.reportService.exportReminderMessageStatusData(
      this.selectedCompanyIds,
      typeof this.startDate === 'string' ? this.startDate : formatDate(this.startDate, 'dd/MM/yyyy', 'en-IN'),
      typeof this.endDate === 'string' ? this.endDate : formatDate(this.endDate, 'dd/MM/yyyy', 'en-IN')
    ).subscribe((response: any) => {
      if (response["Success"] === true && response["Data"] != null && response["Data"].length > 0) {
        this.flattenedExportData = response["Data"];
        setTimeout(() => {
          this.ReminderMessageStatusReport.save();
        }, 0);
        this.loaderService.hide()
      } else {
        this.loaderService.hide();
        this.toaster.error('No data available to generate the report.');
      }
    });
  }

  filteredCompanies(): any[] {
    if (!this.kendoData) return [];
    const search = this.searchControl.value?.toLowerCase() ?? '';
    return this.kendoData.data.filter(c => c.Company.toLowerCase().includes(search));
  }
  toggleSelectAll(event: any): void {
    const filteredIds = this.filteredCompanies().map(c => c.Id);

    if (event.target.checked) {
      this.selectedCompanyIds = Array.from(new Set([
        ...this.selectedCompanyIds,
        ...filteredIds,
      ]));
    } else {
      this.selectedCompanyIds = this.selectedCompanyIds.filter(
        id => !filteredIds.includes(id)
      );
    }
  }

  isAllSelected(): boolean {
    const filteredIds = this.filteredCompanies().map(c => c.Id);
    return filteredIds.every(id => this.selectedCompanyIds.includes(id)) && filteredIds.length > 0;
  }
  onCompanyToggle(id: number, event: any): void {
    if (event.target.checked) {
      this.selectedCompanyIds.push(id);
    } else {
      this.selectedCompanyIds = this.selectedCompanyIds.filter(x => x !== id);
    }
  }

}
